module.exports = __webpack_public_path__ + "img/bg_cod_pad.fa187c29.png";